export { default } from './Dot';
